import { useMemo } from 'react';
import { useSupabaseChats } from './useSupabaseChats';
import { useLeadLabelMap } from './useLeadLabels';

/**
 * Fetches WhatsApp chats for priority leads (Hot/Warm) regardless of message age
 * This ensures high-priority leads are always visible in the chat list
 */
export function usePriorityLeadChats() {
  const leadLabelQuery = useLeadLabelMap(false, true);

  // Extract JIDs of all Hot and Warm leads
  const priorityJids = useMemo(() => {
    if (!leadLabelQuery.data) return [];

    return leadLabelQuery.data
      .filter(lead => lead.label === 'hot' || lead.label === 'warm')
      .map(lead => lead.jid);
  }, [leadLabelQuery.data]);

  // Fetch chats for these specific JIDs (no time filter)
  return useSupabaseChats({
    specificJids: priorityJids,
    enabled: priorityJids.length > 0
  });
}
